import React, { useEffect, useState } from 'react';
import nfllogo from '../Dashboard/img/nfl.png';
import './style.css';

const BreakingNews = ({ sportID, buttonText = 'See More', title, logo, newsItems = [] }) => {
  const newsLimit = 5;
  const [news, setNewsItems] = useState(newsItems);
  const [offset, setOffset] = useState(newsItems.length || 0);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    // When sportID changes, reset to defaultNews and offset
    setNewsItems(newsItems);
    setOffset(newsItems.length || 0);
    setExpandedIndex(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sportID]);

  const fetchNews = async (currentOffset) => {
    const response = await fetch('/api/news', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sportID, limit: newsLimit, offset: currentOffset })
    });
    const data = await response.json();
    console.log(data.data.news,'data?.news');
      setNewsItems(prev => [...prev, ...data.data.news]);
      setOffset(currentOffset + newsLimit);
    
  };

  const handleSeeMore = async () => {
    await fetchNews(offset);
  };

  const handleToggle = (index) => {
    setExpandedIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="breaking-news">
      <div className="container">
        <div className="nfl-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img src={logo} alt="logo" />
          <h4>{title}</h4>
        </div>
        <ul className="news-list collapsed">
          {news.map((item, idx) => {
            const isExpanded = expandedIndex === idx;
            return (
              <li key={idx}>
                <div className={`news-content ${isExpanded ? '' : 'truncated'}`}>
                  {item.Content}
                </div>
                <div className="news-meta">
                  <span className="news-date">
                    {new Date(item.Updated).toLocaleDateString()} • {item.TimeAgo}
                  </span>
                  <button onClick={() => handleToggle(idx)}>
                    {isExpanded ? 'Read Less' : 'Read More'}
                  </button>
                </div>
              </li>
            );
          })}
        </ul>

        {newsItems.length > 0 && newsItems.length % newsLimit === 0 && (
          <button onClick={handleSeeMore}>{buttonText}</button>
        )}
      </div>
    </div>
  );
};

export default BreakingNews;
